import React, { useState, useEffect, useCallback } from 'react'
import { useStore, useDispatch } from 'react-redux'
import { Checkbox, Table } from 'rsuite'
import { getAbbreviatedState } from '../../../services/helper'
import { Link } from "react-router-dom"
import { getLocationBasedMasterSuppliers, getLocationMastersByMasterIds, getSuppliersDataByIds } from '../../../redux/actions/vendor'
import { toast } from '../../CommonComponents/ToastComponent/toast'
import LoaderComponent from '../../CommonComponents/LoaderComponent'

const { Column, HeaderCell, Cell, Pagination } = Table

export const LinkCell = ({ rowData, dataKey, list, ...props }) => {
    let status = ''
    let bgColorClass = ''

    if (dataKey === 'acceptanceType') {
        let masterDetails = list?.find(sup => sup?.id === rowData?.matchedSupplierId)
        return (
            <Cell {...props} className="table-link matched-vendors-table-cell text-black" >
                {masterDetails?.acceptanceType}
            </Cell>
        )
    }

    if (dataKey === 'qaStatus') {
        status = rowData['approvedByManager'] === true ? 'Approved' : rowData['approvedByManager'] === false ? 'Rejected' : 'Pending'
        bgColorClass = status && status.toLowerCase() === 'approved' ? 'bg-green' : status.toLowerCase() === 'rejected' ? 'bg-red' : 'bg-yellow'
    }
    if (dataKey === 'matchedVendor' || dataKey === 'matchedAddress1') {
        let supplier = list?.find((sup) => sup?.id === rowData?.matchedSupplierId)
        if (supplier) {
            if (supplier?.isMaster && !supplier?.masterId) {
                rowData[dataKey] = dataKey === 'matchedVendor' ? <Link target="_blank" to={`/suppliers/${supplier?.id}`}>{supplier?.suppliername}</Link> : supplier?.address1
            } else {
                rowData[dataKey] = dataKey === 'matchedVendor' ? <Link target="_blank" to={`/suppliers/relatedsupplier/${supplier?.id}`}>{supplier?.suppliername}</Link> : supplier?.address1
            }
        }
    }

    if (dataKey === 'masterSupplierName') {
        let masterDetails = list?.find(sup => sup?.id === rowData?.matchedSupplierId)
        rowData[dataKey] = <Link target="_blank" to={`/suppliers/${masterDetails?.masterSupplierId}`}>{masterDetails?.masterSupplierName}</Link>
    }

    if (dataKey === 'state' && rowData[dataKey]) {
        rowData[dataKey] = getAbbreviatedState('', rowData[dataKey])
    }
    return (
        <Cell {...props} className="table-link matched-vendors-table-cell">
            {dataKey === 'qaStatus' ?
                <h5 style={{ width: '60px' }} className={`btn text-white ${bgColorClass}`}>
                    {dataKey === 'qaStatus' ? status : rowData[dataKey]}
                </h5>
                :
                rowData[dataKey]
            }
        </Cell>
    )
}


export const TableCell = ({ rowData, dataKey, onClick, ...props }) => {

    return (
        <Cell {...props} className="table-link matched-vendors-table-cell text-black" id={rowData.id} title={rowData?.[dataKey]}>
            {rowData[dataKey]}
        </Cell>
    )
}

const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
    <Cell {...props} style={{ padding: 0, display: 'flex', alignItems: 'center', margin: 0 }}>
        <Checkbox
            value={rowData[dataKey]}
            onChange={onChange}
            checked={checkedKeys.some(item => item === rowData[dataKey])}
        />
    </Cell>
);

const MatchedVendors = ({ tabledata, total, matchedVendorsColumns, listId, onGetTableData, currentTab, searchValue, handleCheckAll, handleCheck, checkedKeys, checked, indeterminate, handleRemoveMatchedSuppliers, matchedVendorPage, setMatchedVendorPage, onSetRowLimit }) => {
    const store = useStore().getState()
    const dispatch = useDispatch()
    const {
        vendor: { allSuppliers },
    } = store

    const [limit, setLimit] = useState(10)
    const [tableData, setTableData] = useState([])
    const [totalData, setTotalData] = useState(0)
    const [sortColumn, setSortColumn] = useState('suppliername');
    const [sortType, setSortType] = useState('asc');
    const [masterSupplierList, setMasterSupplierList] = useState([])

    useEffect(() => {
        onGetTableData(1, 10, 'matched', "", "suppliername", "asc")
    }, [])

    const getTableData = useCallback(async (tabledata) => {
        let finalResponse = []
        let matchedSuppliersId = tabledata?.map(sup => sup?.matchedSupplierId)
        if (matchedSuppliersId?.length) {
            await dispatch(getSuppliersDataByIds(matchedSuppliersId, [], true)).then(async (res) => {
                let mainMasterIds = res.filter(sup => sup?.isAcceptGlobalAcceptance === false).map(sup => sup?.masterSupplierId)

                let locationMasters = []
                if (mainMasterIds?.length > 0) {
                    locationMasters = await dispatch(getLocationMastersByMasterIds(mainMasterIds)).then((locMasters) => {
                        return locMasters
                    }).catch(err => {
                        toast.show({
                            title: 'Warning',
                            description: 'Failed To Get Location Masters',
                        })
                    })


                }
                finalResponse = res.map(sup => {
                    let locationMas = locationMasters?.find(master => master.masterId === sup.masterSupplierId)

                    if (sup?.isAcceptGlobalAcceptance === true) {
                        sup.acceptanceType = 'Global'
                    } else if (sup?.isAcceptGlobalAcceptance === null) {
                        sup.acceptanceType = 'Unknown'
                    } else if (locationMas?.id) {
                        sup.acceptanceType = 'Location'
                    } else {
                        sup.acceptanceType = 'Selective'
                    }
                    return sup
                })
                setMasterSupplierList(finalResponse)
            }).catch(err => {
                toast.show({
                    title: 'Warning',
                    description: 'Failed To Get Supplier Data',
                })
            })
        }

        setTableData(tabledata)
        setTotalData(total)
    })

    useEffect(() => {
        if (!tabledata || tabledata?.length === 0) {
            setTableData([])
            setTotalData(0)
            return
        }
        getTableData(tabledata)
    }, [tabledata])

    const handleChangeLimit = dataKey => {
        setMatchedVendorPage(1);
        onSetRowLimit(dataKey);
        setLimit(dataKey);
        onGetTableData(1, dataKey, 'matched', searchValue, "suppliername", "asc")
    }

    const handleChangePage = (event) => {
        setMatchedVendorPage(event)
        onGetTableData(event, limit, 'matched', searchValue, sortColumn, sortType)
    }

    const headerElements = matchedVendorsColumns.map((col, index) => {
        if (col.name === 'partnerSupplierId' || col.name === 'accountNumber') {
            return
        }
        if (col.name === 'matchedVendor' || col.name === 'matchedAddress1' || col.name === 'masterSupplierName' || col.name === 'acceptanceType') {
            return (
                <Column
                    resizable
                    sortable={(index === 7 || index === 8) && false}
                    key={col.name}
                >
                    <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                    <LinkCell dataKey={col.name} list={masterSupplierList} />
                </Column>
            )
        }

        if (col.name === 'matchScore') {
            return (
                <Column
                    resizable
                    sortable={true}
                    key={col.name}
                >
                    <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                    <Cell className="table-link matched-vendors-table-cell text-black" dataKey={col.name}>
                        {rowData => <p>{rowData?.matchScore ? parseFloat(rowData?.matchScore)?.toFixed(2) : ''}</p>}
                    </Cell>
                </Column>
            )
        }

        return (
            <Column
                resizable
                sortable
                key={col.name}
            >
                <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                <TableCell className='text-black' dataKey={col.name} />
            </Column>
        )
    })

    const handleSortColumn = (sortColumn, sortType) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
        onGetTableData(matchedVendorPage, limit, currentTab, searchValue, sortColumn, sortType)
    }

    return (
        
        <>
            <div className={`border border-2 border-top-0`}>
                <Table
                    id='matched-vendors-table'
                    className='matched-vendors-table'
                    virtualized={true}
                    autoHeight
                    affixHeader={true}
                    data={tableData}
                    sortColumn={sortColumn}
                    sortType={sortType}
                    onSortColumn={handleSortColumn}
                >
                    <Column width={50} align="center" >
                        <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Checkbox
                                checked={checked}
                                indeterminate={indeterminate}
                                onChange={handleCheckAll}
                            />
                        </HeaderCell>
                        <CheckCell dataKey="id" checkedKeys={checkedKeys} onChange={handleCheck} />
                    </Column>
                    {headerElements}
                </Table>
                <div className="matched-vendor-table-pagination">
                    <Pagination
                        prev
                        next
                        first={true}
                        last={true}
                        maxButtons={5}
                        activePage={matchedVendorPage}
                        showInfo
                        layout={['limit', '|', 'pager']}
                        displayLength={limit}
                        lengthMenu={[
                            {
                                label: '10',
                                value: 10,
                            },
                            {
                                label: '20',
                                value: 20,
                            },
                            {
                                label: '30',
                                value: 30,
                            },
                            {
                                label: '50',
                                value: 50,
                            },
                            {
                                label: '100',
                                value: 100,
                            },
                        ]}
                        total={totalData}
                        onChangeLength={handleChangeLimit}
                        onChangePage={(event) => { handleChangePage(event) }}
                    />
                </div>
            </div>
        </>
    )
}

export default MatchedVendors